package com.essntl.uikit.components.input

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import core.validation.EsInputState

@Composable
fun EsPhoneInput(
    value: Long,
    onValueChange: (Long) -> Unit,
    label: String? = null,
    message: String? = null,
    placeholder: String? = null,
    suffix: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    onClear: () -> Unit = {},
    readOnly: Boolean = !enabled,
    state: EsInputState = EsInputState.Default,
    keyboardOptions: KeyboardOptions =
        KeyboardOptions.Default.copy(
            keyboardType = KeyboardType.Decimal,
            autoCorrectEnabled = false,
        ),
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    singleLine: Boolean = false,
    maxLines: Int = if (singleLine) 1 else Int.MAX_VALUE,
    minLines: Int = 1,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    cursorColor: Color = Color.Unspecified,
    visualTransformation: VisualTransformation = VisualTransformation.None,
    shape: Shape = RoundedCornerShape(12.dp),
    modifier: Modifier = Modifier,
) {
    var selection by remember {
        mutableStateOf(TextRange.Zero)
    }
    var textFieldValue by remember {
        mutableStateOf(TextFieldValue())
    }

    LaunchedEffect(value, selection) {
        textFieldValue =
            if (value == 0L) {
                TextFieldValue()
            } else {
                TextFieldValue(
                    text = value.toString(),
                    selection = selection,
                )
            }
    }

    EsInput(
        value = textFieldValue,
        onClear = onClear,
        onValueChange = {
            val stringInt = it.text.trim().replace(Regex("[^0-9.]"), "")

            val newValue =
                if (stringInt.isEmpty()) {
                    0L
                } else {
                    stringInt.toLongOrNull() ?: return@EsInput
                }

            selection = it.selection

            onValueChange(newValue)
        },
        label = label,
        message = message,
        placeholder = placeholder,
        prefix = {
            Text(
                text = "+",
                textAlign = TextAlign.Center,
            )
        },
        suffix = suffix,
        showClearButton = false,
        enabled = enabled,
        readOnly = readOnly,
        state = state,
        visualTransformation = visualTransformation,
        keyboardOptions = keyboardOptions,
        keyboardActions = keyboardActions,
        singleLine = singleLine,
        maxLines = maxLines,
        minLines = minLines,
        interactionSource = interactionSource,
        cursorColor = cursorColor,
        shape = shape,
        modifier = modifier,
    )
}
